var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronCircleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0004 2.77767C6.45937 2.77767 2.77816 6.45888 2.77816 10.9999C2.77816 15.5409 6.45937 19.2221 11.0004 19.2221C15.5414 19.2221 19.2226 15.5409 19.2226 10.9999C19.2226 6.45888 15.5414 2.77767 11.0004 2.77767ZM1.44482 10.9999C1.44482 5.7225 5.72299 1.44434 11.0004 1.44434C16.2778 1.44434 20.5559 5.7225 20.5559 10.9999C20.5559 16.2773 16.2778 20.5554 11.0004 20.5554C5.72299 20.5554 1.44482 16.2773 1.44482 10.9999ZM9.19564 7.86182C9.45599 7.60147 9.8781 7.60147 10.1385 7.86182L12.8051 10.5285C13.0655 10.7888 13.0655 11.2109 12.8051 11.4713L10.1385 14.138C9.8781 14.3983 9.45599 14.3983 9.19564 14.138C8.93529 13.8776 8.93529 13.4555 9.19564 13.1952L11.3909 10.9999L9.19564 8.80463C8.93529 8.54428 8.93529 8.12217 9.19564 7.86182Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronCircleRight);
export default __webpack_public_path__ + "static/media/chevronCircleRight.8a03c5ee0588ca9d0d69828769a0d294.svg";
export { ForwardRef as ReactComponent };